<template>
    <div class="codics-aonaer-info-sys-poster-detail-body">
        <WebHeader></WebHeader>
        <div class="codics-aonaer-info-sys-poster-detail-box" style="margin-top: 160px;">
            <div class="codics-aonaer-info-sys-poster-detail-container">
                <div class="codics-aonaer-info-sys-poster-detail-tab">
                    <div class="codics-aonaer-info-sys-poster-detail-tab-item" v-for="(item, index) in lunboData"
                        :style="{ 'border': index == nowIndex ? '1px solid #ea5b18' : '1px solid #EEE' }" :key="index"
                        @mouseenter="changeSwipper(index)">
                        <el-image class="codics-aonaer-info-sys-poster-detail-tab-item-img"
                            :src="'https://cdn.bosscaigou.com/' + item" fit="contain"></el-image>
                    </div>
                </div>
                <div class="codics-aonaer-info-sys-poster-detail-swipper-box">
                    <div class="swiper-container codics-aonaer-info-sys-poster-detail-swipper-container">
                        <div class="swiper-wrapper">
                            <div v-for="(item, index) in lunboData" :key="index.id" class="swiper-slide">
                                <el-image class="codics-aonaer-info-sys-poster-detail-swipper-item-img"
                                    :src="'https://cdn.bosscaigou.com/' + item" fit="contain"></el-image>
                            </div>
                        </div>
                        <div class="swiper-pagination"></div>
                        <div
                            class="swiper-button-next codics-aonaer-info-sys-poster-detail-swipper-btn codics-aonaer-info-sys-poster-detail-swipper-next iconfont">
                            &#xe7a2;
                        </div>
                        <div
                            class="swiper-button-prev codics-aonaer-info-sys-poster-detail-swipper-btn codics-aonaer-info-sys-poster-detail-swipper-prev iconfont">
                            &#xe7a3;
                        </div>
                    </div>
                </div>
                <div class="codics-aonaer-info-sys-poster-detail-swipper-line">
                    <div class="codics-aonaer-info-sys-poster-detail-info-box">
                        <div class="codics-aonaer-info-sys-poster-detail-info-title">春节海报</div>
                        <div class="codics-aonaer-info-sys-poster-detail-info-content">
                            <span>数量：{{ hbData?.img?.split(',')?.length }}张</span><br>
                            <span style="word-wrap: break-word;overflow-wrap: break-word;">文案：{{ hbData.zip
                                }}</span><br>
                            <span>尺寸：{{ hbWidth + '*' + hbHeight }} px</span>
                        </div>
                        <div class="codics-aonaer-info-sys-poster-detail-info-btn-box">
                            <div class="codics-aonaer-info-sys-poster-detail-info-btn iconfont"
                                style="color: #333;background: #EEE">&#xe747; 扫码分享</div>
                            <div class="codics-aonaer-info-sys-poster-detail-info-qrcode">
                                <img class="codics-aonaer-info-sys-poster-detail-info-qrcode-img" :src="qrImg"
                                    alt="扫码分享">
                            </div>
                            <div class="codics-aonaer-info-sys-poster-detail-info-btn iconfont"
                                style="margin-left: 20px;" @click="downloadImages(hbData)">&#xe854; 立即下载</div>
                        </div>

                    </div>
                    <div class="codics-aonaer-info-sys-poster-detail-info-box codics-aonaer-info-sys-poster-detail-other-box"
                        style="margin-top: 20px;">
                        <div
                            class="codics-aonaer-info-sys-poster-detail-info-title codics-aonaer-info-sys-poster-detail-other-title">
                            最新海报</div>
                        <div class="codics-aonaer-info-sys-poster-detail-other-item" v-for="(item, index) in imgList"
                            :style="{ 'margin-left': index == 0 ? '20px' : '10px' }" :key="index" :data-content="'春节海报'"
                            @click="jumpToPage(item.id)">
                            <img :src="initImg(item.img)" :alt="''">
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <WebFooter></WebFooter>
    </div>
</template>

<script>
import WebHeader from '@/components/WebHeader';
import WebFooter from '@/components/WebFooter';
import Swiper from 'swiper';
import 'swiper/css/swiper.min.css';
import { infoPoster } from '@/api';
import QRCode from 'qrcode';
import { copyTxt, downloadImage, randomString, getImageSize } from '@/utils/myutils';
export default {
    data() {
        return {
            qrImg: "",
            swiper: null,
            nowIndex: 0,
            hbData: {},
            lunboData: [],
            imgList: [],
            hbWidth: 0,
            hbHeight: 0
        }
    },
    mounted() {
        this.initSwiper();
        this.infoPosterfuc();
        this.creatQrCode(window.location + "");
    },
    methods: {
        downloadImages(item) {
            let data = item.img.split(',');
            data.forEach(item => {
                downloadImage('https://cdn.bosscaigou.com/' + item, 'aonaer_haibai_' + randomString(10) + '.png');
            });
            copyTxt(item.zip);
            this.$message({
                message: '海报已保存，文案已复制到剪切板！',
                type: 'success'
            });
        },
        async creatQrCode(QRlink) {   // QRlink是二维码的内容
            let _this = this;
            let opts = {
                errorCorrectionLevel: "L",//容错级别
                type: "image/png",//生成的二维码类型
                quality: 0.3,//二维码质量
                margin: 1,//二维码留白边距
                width: 100,//宽
                height: 100,//高
                text: QRlink,//二维码内容
                color: {
                    dark: "#000",//前景色
                    light: "#fff"//背景色
                }
            };
            QRCode.toDataURL(QRlink, opts, (err, url) => {
                if (err) throw err
                //将生成的二维码路径复制给data的QRImgUrl
                // console.log(url)
                _this.qrImg = url;
            })
        },
        jumpToPage(n) {
            window.location = window.location.origin + '/hb_detail/' + n;
        },
        async infoPosterfuc() {

            let _this = this;

            let data = await infoPoster({ id: this.$route.params.id });

            if (data.code == 200) {

                this.hbData = data.data;

                this.lunboData = data.data.img.split(',');

                this.imgList = [...data.data1, ...data.data2];

                console.log(this.initImg(this.hbData.img))

                getImageSize(this.initImg(this.hbData.img), (a) => {

                    _this.hbWidth = a.width;

                    _this.hbHeight = a.height;

                });

            } else {

                this.$message.error(data.message);

            }

        },
        initImg(str) {
            return str == '' ? '' : ('https://cdn.bosscaigou.com/' + str.split(',')[0]);
        },
        initSwiper() {
            let _this = this;
            this.swiper = new Swiper(".swiper-container", {
                loop: false, // 无缝
                autoplay: { //自动开始
                    delay: 8000, //时间间隔
                    disableOnInteraction: false, //*手动操作轮播图后不会暂停*
                },
                paginationClickable: true,
                fade: { crossFade: true },
                slidesPerView: 1, // 一组三个
                spaceBetween: 0, // 间隔
                // 如果需要前进后退按钮
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                // 窗口变化,重新init,针对F11全屏和放大缩小,必须加
                observer: true,
                observeParents: true,
                // 如果需要分页器
                // pagination: {
                //     el: '.swiper-pagination',
                //     clickable: true, // 分页器可以点击
                // },
                on: {
                    click: (e) => {

                        console.log(e)

                        var clickedSlide = e.target.closest('.swiper-slide');
                        if (clickedSlide) {
                            console.log(clickedSlide, _this.swiper.slides)
                            // 获取点击元素的index
                            var index = Array.from(_this.swiper.slides).indexOf(clickedSlide);
                            console.log('Clicked slide index:', index % 5);
                            this.swiper && this.swiper.slideTo(index % 5, 300);
                        }

                    },
                    transitionStart: function (swiper) {
                        _this.nowIndex = this.realIndex;
                    },
                    transitionEnd: function () {

                        if (_this.swiperState) {
                            console.log(this.realIndex)
                            _this.flyTo({
                                position: _this.swiperList[this.realIndex].from || [0, 200, 0],
                                controls: _this.swiperList[this.realIndex].to || [0, 0, 0],
                                done: () => {

                                }
                            })
                        }
                    }
                },
            })
        },
        changeSwipper(idx) {

            this.swiper && this.swiper.slideTo(idx, 300);

        }
    },
    components: {
        WebHeader,
        WebFooter
    }
}
</script>

<style>
.codics-aonaer-info-sys-poster-detail-body {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    background: #F7F7F7;
}

.codics-aonaer-info-sys-poster-detail-box {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-poster-detail-container {
    height: fit-content;
    width: 100%;
    max-width: 1360px;
    position: relative;
    float: left;
    left: 50%;
    transform: translateX(-50%);
    margin-bottom: 60px;
}

.codics-aonaer-info-sys-poster-detail-tab {
    height: fit-content;
    width: 90px;
    position: relative;
    float: left;
}

.codics-aonaer-info-sys-poster-detail-tab-item {
    height: 90px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    border-radius: 5px;
    background: #FFF;
    border: 1px solid #EEE;
    box-shadow: 0 0 1px rgba(0, 0, 0, .1);
    transition: .3s;
    cursor: pointer;
    margin-bottom: 15px;
}

.codics-aonaer-info-sys-poster-detail-tab-item:hover {
    box-shadow: 0 0 5px rgba(0, 0, 0, .1);
}

.codics-aonaer-info-sys-poster-detail-tab-item-img {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
}

.codics-aonaer-info-sys-poster-detail-swipper-box {
    height: 700px;
    width: calc(100% - 550px);
    position: relative;
    float: left;
    box-sizing: border-box;
    border-radius: 5px;
    border: 1px solid #EEE;
    background: #FFF;
    margin-left: 30px;
}

.codics-aonaer-info-sys-poster-detail-swipper-container {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-poster-detail-swipper-item-img {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
}

.codics-aonaer-info-sys-poster-detail-swipper-btn {
    height: 40px;
    width: 40px;
    border-radius: 20px;
    border: 1px solid #EEE;
    background: #FFF;
    line-height: 40px;
    text-align: center;
    color: #333;
    transition: .3s;
    font-size: 15px;
}

.codics-aonaer-info-sys-poster-detail-swipper-btn:hover {
    color: #FFF;
    background: #ea5b18;
    border: 1px solid #ea5b18;
}

.codics-aonaer-info-sys-poster-detail-swipper-btn::after {
    content: '' !important;
}

.codics-aonaer-info-sys-poster-detail-swipper-line {
    height: fit-content;
    width: 400px;
    position: relative;
    float: left;
    box-sizing: border-box;
    margin-left: 30px;
}

.codics-aonaer-info-sys-poster-detail-info-box {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    background: #FFF;
    border-radius: 5px;
    border: 1px solid #EEE;
}

.codics-aonaer-info-sys-poster-detail-info-title {
    height: 66px;
    width: 100%;
    position: relative;
    float: left;
    border-bottom: 1px solid #F7F7F7;
    line-height: 66px;
    box-sizing: border-box;
    padding: 0 20px;
    font-size: 20px;
    font-weight: bold;
    color: #333;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}

.codics-aonaer-info-sys-poster-detail-info-content {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 20px;
    font-size: 16px;
    color: #aaa;
    line-height: 30px;
}

.codics-aonaer-info-sys-poster-detail-info-btn-box {
    height: 80px;
    width: 100%;
    position: relative;
    float: left;
    border-top: 1px solid #F7F7F7;
    box-sizing: border-box;
    padding: 20px 20px;
}

.codics-aonaer-info-sys-poster-detail-info-btn {
    height: 40px;
    width: calc(50% - 10px);
    position: relative;
    float: left;
    line-height: 40px;
    text-align: center;
    font-size: 14px;
    color: #FFF;
    background: #ea5b18;
    border-radius: 5px;
    cursor: pointer;
    transition: .3s;
    user-select: none;
    -webkit-user-drag: none;
}

.codics-aonaer-info-sys-poster-detail-info-btn:hover {
    background: #EE7C46 !important;
    color: #FFF !important;
}

.codics-aonaer-info-sys-poster-detail-info-qrcode {
    height: 120px;
    width: 120px;
    position: absolute;
    margin: auto;
    bottom: 73px;
    left: 45px;
    border-radius: 20px;
    box-sizing: border-box;
    padding: 5px;
    border-radius: 5px;
    border: 1px solid #F7F7F7;
    background: #FFF;
    box-shadow: 0 0 12px rgba(0, 0, 0, .2);
    opacity: 0;
    visibility: hidden;
    transition: .3s;
}

.codics-aonaer-info-sys-poster-detail-info-qrcode-img {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    object-fit: fill;
}

.codics-aonaer-info-sys-poster-detail-info-qrcode::after {
    content: '';
    height: 10px;
    width: 10px;
    position: absolute;
    margin: auto;
    left: 0;
    right: 0;
    bottom: -6px;
    transform: rotate(45deg);
    border-right: 1px solid #EEE;
    border-bottom: 1px solid #EEE;
    background: #FFF;
}

.codics-aonaer-info-sys-poster-detail-info-btn:hover+.codics-aonaer-info-sys-poster-detail-info-qrcode {
    opacity: 1;
    visibility: visible;
}

.codics-aonaer-info-sys-poster-detail-other-box {
    height: 350px !important;
}

.codics-aonaer-info-sys-poster-detail-other-item {
    height: 244px;
    width: calc(33.333333% - 20px);
    position: relative;
    float: left;
    margin-top: 20px;
    border-radius: 5px;
    overflow: hidden;
    cursor: pointer;
}

.codics-aonaer-info-sys-poster-detail-swipper-next {
    right: 25px !important;
}

.codics-aonaer-info-sys-poster-detail-swipper-prev {
    left: 25px !important;
}

.codics-aonaer-info-sys-poster-detail-other-item img {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    object-fit: fill;
    user-select: none;
    -webkit-user-drag: none;
    transition: .3s;
}

.codics-aonaer-info-sys-poster-detail-other-item::before {
    content: '';
    height: 100%;
    width: 100%;
    position: absolute;
    margin: auto;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, .5);
    transition: .3s;
    opacity: 0;
    z-index: 1;
    visibility: hidden;
}

.codics-aonaer-info-sys-poster-detail-other-item:hover::before {
    opacity: 1 !important;
    visibility: visible !important;
}

.codics-aonaer-info-sys-poster-detail-other-item:hover img {
    transform: scale(1.05);
}

.codics-aonaer-info-sys-poster-detail-other-item::after {
    content: attr(data-content);
    height: 40px;
    width: 100%;
    position: absolute;
    margin: auto;
    left: 0;
    bottom: 0;
    background: linear-gradient(to top, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0));
    line-height: 40px;
    text-align: center;
    font-size: 14px;
    color: #FFF;
    box-sizing: border-box;
    padding: 0 10px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    user-select: none;
    -webkit-user-drag: none;
    z-index: 2;
}

@media (max-width: 768px) {
    .codics-aonaer-info-sys-poster-detail-tab {
        height: 90px !important;
        width: 100% !important;
    }

    .codics-aonaer-info-sys-poster-detail-tab-item {
        width: 90px !important;
        margin-left: 15px !important;
    }

    .codics-aonaer-info-sys-poster-detail-swipper-box {
        width: 100% !important;
        margin-left: 0 !important;
        margin-top: 15px !important;
    }

    .codics-aonaer-info-sys-poster-detail-box {
        margin-top: 120px !important;
    }

    .codics-aonaer-info-sys-poster-detail-swipper-line {
        width: 100% !important;
        margin-left: 0 !important;
        margin-top: 20px !important;
    }

    .codics-aonaer-info-sys-poster-detail-container {
        margin-bottom: 20px !important;
    }
}
</style>